import API from 'services/API';

export default function refuseRelations(data) {
  return API.request({
    method: 'POST',
    url: '/guardianship/refuse',
    data,
  });
}
